import styled from '@emotion/styled'
import { EDigitalAccountStatus, colorDigitalAccount } from '~/utils'

type ContainerProps = {
  status: EDigitalAccountStatus;
}
export const Container = styled.div<ContainerProps>`

  span {
    ${(props) => colorDigitalAccount(props.status)}
    padding: .2rem .6rem;
    border-radius: .4rem;
    font-weight: 600;
    font-size: .8rem;
  }

`
